import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck, Clock } from "lucide-react";
import { api, formatApiError } from "../api/client";
import { Button } from "../components/ui/button";
import { Badge } from "../components/ui/badge";
import { toast } from "sonner";

export default function Frameworks() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get("/frameworks");
        if (!cancelled) setItems(data);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const activate = async (code) => {
    try {
      await api.post(`/organization/frameworks/${code}/activate`);
      toast.success("Framework activado.");
      navigate(`/questionnaire/${code}`);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    }
  };

  return (
    <div data-testid="frameworks-page" className="max-w-4xl">
      <h1 className="text-[20px] font-semibold tracking-tight text-slate-900">Frameworks normativos</h1>
      <p className="text-[14px] text-slate-500 mt-1">Activa los marcos que aplican a tu organización.</p>

      <div className="mt-6 grid grid-cols-2 gap-4">
        {loading && <div className="text-slate-500">Cargando...</div>}
        {items.map((f) => (
          <div key={f.code} className="border border-slate-200 rounded-md p-5 bg-white" data-testid={`fw-card-${f.code}`}>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                {f.status === "available" ? <ShieldCheck className="h-5 w-5 text-primary" /> : <Clock className="h-5 w-5 text-slate-400" />}
                <span className="font-semibold text-slate-900">{f.name}</span>
              </div>
              {f.status === "coming_soon" ? (
                <Badge variant="secondary">Próximamente</Badge>
              ) : f.activated ? (
                <Badge>Activado</Badge>
              ) : (
                <Badge variant="outline">Disponible</Badge>
              )}
            </div>
            <p className="text-[12px] text-slate-500 mt-2">v{f.version} · {f.language?.toUpperCase()} · {f.total_controls} controles</p>
            <p className="text-[14px] text-slate-700 mt-3">{f.description}</p>
            <div className="mt-4">
              {f.status === "coming_soon" ? (
                <Button disabled variant="outline">Próximamente</Button>
              ) : f.activated ? (
                <Button variant="outline" onClick={() => navigate(`/soa?framework=${f.code}`)} data-testid={`fw-soa-${f.code}`}>Ver SoA</Button>
              ) : (
                <Button onClick={() => activate(f.code)} data-testid={`fw-activate-${f.code}`}>Activar framework</Button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
